import { loc } from "../../../core/utils"
import CheckboxField from "../../../form/CheckboxField"
import Number from "../../../form/Date"
import NumberField from "../../../form/NumberField"
import { TunnelDataContext } from "../../context/TunnelDataContext"
import React, { Fragment, useContext } from "react"
import { Col, Form, Row } from "react-bootstrap"

const AxeptaCBForm = ({ certifySignature }) => {
  const { tunnelData } = useContext(TunnelDataContext)

  return (
    <Fragment>
      <Row>
        <Col md={6} sm={12} className="order-md-1">
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>{loc`Card number`}</Form.Label>
              <Row>
                <Col lg={12}>
                  <Number name="cardNumber" format="#### #### #### ####" placeholder=" " />
                </Col>
              </Row>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} lg={5}>
              <Form.Label>{loc`Expiration date`}</Form.Label>
              <Row noGutters>
                <Col>
                  <NumberField
                    noFormGroup
                    placeholder={loc`MM`}
                    className="form-control"
                    type="number"
                    name="month"
                    inputmode="numeric"
                  />
                </Col>
                <Col>
                  <NumberField
                    noFormGroup
                    placeholder={loc`YYYY`}
                    className="form-control"
                    type="number"
                    name="year"
                    inputmode="numeric"
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group as={Col} lg={{ span: 6, offset: 1 }} sm={6}>
              <NumberField
                noFormGroup
                placeholder={loc`CVV`}
                label={loc`CVV`}
                className="form-control"
                type="number"
                name="cvv"
                inputmode="numeric"
              />
            </Form.Group>
          </Form.Row>
          <Col className="order-md-1 p-0">
            <CheckboxField
              label={loc`I, undersigned ${certifySignature} certify that I am the holder of the bank card used for the request for payment of my 1st payment.`}
              name="userIsRealCardOwner"
              className="flex-nowrap optin p-0"
            />
          </Col>
        </Col>

        <Col md={6} sm={12} className="order-last order-md-2">
          <ul className="border-list-block list-unstyled">
            <li>
              <h3 className="ico-success-medium-before">{loc`Cards accepted`}</h3>
              {tunnelData.cbPageLogos.map((logo) => (
                <img key={logo} src={process.env.PUBLIC_URL + "/images/" + logo + ".png"} alt="" />
              ))}
            </li>
            <li>
              <h3 className="ico-danger-medium-before">{loc`Cards not accepted`}</h3>
              <p>
                <small>{loc`Systematic authorization cards (Electron, Maestro, pre-paid or rechargeable), American Express and e-CB.`}</small>
              </p>
            </li>
          </ul>
        </Col>
      </Row>
    </Fragment>
  )
}

export default AxeptaCBForm
